@if (loadingUsers===false){
<ng-template #affixTemplate let-row>
  <app-card-table-actions [row]="row" [actions]="row.accessRevoked ? rowActionsGrant : rowActionsRevoke"
    (actionEvent)="onAction($event)" [breakpoint]="ScreenSize.TABLET"></app-card-table-actions>
</ng-template>

<app-generic-table-header [config]="headerOptions" (newItemAdded)="openUserModal(null)"
  (refreshEvent)="refreshTable($event)"></app-generic-table-header>

@if (tableData != null && tableData.length > 0) {
<app-card-table #UserTable [tableHeaders]="headers" [data]="tableData" [options]="options"
  [affixTemplate]="userHasWriteAccess ? affixTemplate : null" [enableInfiteScroll]="false"
  [enableTablePagination]="true" [enableRefresher]="true" (dataRefreshedEvent)="refreshData($event)"
  [totalItems]="totalUsers" [currentPage]="currentUserPage" (paginateEvent)="getPagedUsers($event)"
  [breakpoint]="ScreenSize.TABLET">
</app-card-table>
} @if (tableData.length == 0 && isLoaded) {
<p class="text-align-center">No results were found.</p>
}
} @else {
<div class="loading">
  <mat-spinner diameter="50"></mat-spinner>
</div>
}